<div class="notification" *ngIf="orderItem">
  <div class="note d-flex justify-content-between align-items-center border-bottom-color ps-3">
    <small class="text-nowrap">{{ orderItem.quantity }} items has been added to your bag.</small>
    <x-close-button (click)="closeOverlay()"></x-close-button>
  </div>

  <div class="order-item-wrap p-3 border-bottom-color">
    <div class="order-item">
      <x-media-thumbnail
        [url]="orderItem.media.url"
        width="65"
        height="65"
        crop="fit"
      ></x-media-thumbnail>
      <div class="info">
        <div class="name mat-body-1 m-0">
          {{ orderItem.productName }}
        </div>
      </div>
    </div>
    <button mat-flat-button color="primary" class="mt-2 w-100" (click)="viewBag()">View bag</button>
  </div>

  @if (association) {
    <x-association-add-to-bag
      class="p-3"
      [associationWithProducts]="association"
    ></x-association-add-to-bag>
  }
</div>
